function onPause(event) {
  this.props.onPause(event);
}

export default onPause;
